import { FC, forwardRef, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import {
  Alert,
  AlertColor,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import {
  attachmentModule,
  caseManagement,
  EArchType,
  orderView,
  stageControl,
  stagingManager,
  toothMovement,
  viewControlInTreatment,
  viewEdit,
  wasmModule,
} from "@/gluelayer"
import { isEmpty } from "lodash"

import { useAppDispatch, useAppSelector, useDeepEffect } from "@/core/app/hooks"
import { UText } from "@/components/index"
import { RootState } from "@/core/app/store"
import {
  getQuotation,
  getStageDetailApi,
} from "../../../core/app/slices/order/orderThunkApi"
import { getQuoteRequestObj } from "@/modules/Patient/PatientList/util/commonUtil"
import { refinementModule } from "@/gluelayer/core/modules/refinement/index"
import { setRefinementNum } from "@/UDTreat/udTreatSlice"

import orderandprint from "../../../assets/svgs/stagebg.svg"
import { set } from "react-hook-form"
const BaseButton = styled(Button)({
  width: 34,
  height: 34,
  minWidth: 34,
  padding: 0,
  color: "rgba(0, 0, 0, 0.87)",
  border: "1px solid",
  borderRadius: 4,
})
import { useImperativeHandle } from "react"

export type reviewStageComponentHandle = {
  resetCuttintlineFunc: () => void
}
const ReviewPrintStage = forwardRef<reviewStageComponentHandle>(
  (props, ref) => {
    useImperativeHandle(ref, () => ({
      resetCuttintlineFunc() {
        resetCuttingLine()
      },
    }))
    const { caseId, patientId } = useParams()
    const dispatch = useAppDispatch()
    const [upperStage, setupperStage] = useState<
      { stepindex: number; name: string }[]
    >([])
    const [lowerStage, setlowerStage] = useState<
      { stepindex: number; name: string }[]
    >([])
    const { refinementNum, printedStageInPrint } = useAppSelector(
      (state: RootState) => state.udTreatService,
    )
    const [up_current, setup_current] = useState(0)
    const [down_current, setdown_current] = useState(0)

    const [printedStage, setprintedStage] = useState<{
      up: number[]
      low: number[]
    }>({
      up: [],
      low: [],
    })

    const [orderStage, setorderStage] = useState<{
      up: number[]
      low: number[]
    }>({
      up: [],
      low: [],
    })
    const [selectedStage, setselectedStage] = useState<{
      up: number[]
      low: number[]
    }>({
      up: [],
      low: [],
    })

    const [upperReviewStage, setUpperReviewStage] = useState(-1)
    const [lowerReviewStage, setLowerReviewStage] = useState(-1)
    // refinementNum: 0:initial case; >0: refinement case

    // =0:initial case; >0: refinement case
    const [refinements, setrefinements] = useState(null)

    const [firstStage, setfirstStage] = useState<{ up: number; low: number }>({
      up: null,
      low: null,
    })
    const [lastStage, setlastStage] = useState<{ up: number; low: number }>({
      up: null,
      low: null,
    })
    const [attachment, setattachment] = useState<{ up: number; low: number }>({
      up: null,
      low: null,
    })
    const [isControl, setisControl] = useState(false)
    const [retainers, setretainers] = useState<{ up: number; low: number }>({
      up: 0,
      low: 0,
    })
    const [isQuick3, setisQuick3] = useState(false)
    const {
      orderService: { stageDetail },
    } = useAppSelector((state: RootState) => state)
    const { caseDetail } = useAppSelector(
      (state: RootState) => state.caseService,
    )

    const [showCutlineWarning, setShowCutLineWarning] = useState(false)

    useEffect(() => {
      try {
        if (!wasmModule.moduleManager.GetModulePrintSelection()) return
        if (
          printedStageInPrint.up.length == 0 &&
          printedStageInPrint.low.length == 0
        ) {
          wasmModule.moduleManager.GetModulePrintSelection().ClearAllStage()
        }
      } catch (error) {
        console.error(error)
      }
    }, [printedStageInPrint.up.length, printedStageInPrint.low.length])

    const { openReviewPrint } = useAppSelector(
      (state: RootState) => state.udTreatService,
    )

    const getArch = (udesign_category) => {
      let caseArch = "both",
        UpperType = "A",
        LowerType = "A"

      if (!udesign_category) return caseArch
      UpperType = udesign_category.split("/")[0]

      LowerType = udesign_category.split("/")[1]

      if (UpperType.includes("--")) {
        caseArch = "lower"
      } else if (LowerType.includes("--")) {
        caseArch = "upper"
      }

      return { caseArch, UpperType, LowerType }
    }

    // get stageDetail
    useDeepEffect(() => {
      const attachmentModule = wasmModule.statusController.GetAttachmentModel()
      const upTempIndex = attachmentModule.GetAttachmentFirstStage(
        wasmModule.module.ArchType.UpArch,
      )
      const lowerTempIndex = attachmentModule.GetAttachmentFirstStage(
        wasmModule.module.ArchType.DownArch,
      )
      setattachment({
        up: upTempIndex,
        low: lowerTempIndex,
      })

      return () => {
        setUpperReviewStage(-1)
        setLowerReviewStage(-1)
      }
    }, [openReviewPrint])
    /**
     *  解析stageDetail，赋予stage状态
     */
    useEffect(() => {
      if (isEmpty(stageDetail)) return
      let currentStage = []

      let refinementCount = 0
      if (refinementNum === 0) {
        if (!refinementModule) return
        const refinementHistoryList = refinementModule.getRefinementDateInfo()
        refinementCount = Object.keys(refinementHistoryList).length
        dispatch(setRefinementNum(refinementCount))
        setrefinements(refinementCount - 1)
      } else {
        refinementCount = refinementNum
        setrefinements(refinementNum - 1)
      }
      const { jointUpKeypoints, jointLowerKeypoints } =
          stagingManager.wasmStageData,
        up_res = [],
        low_res = []
      if (refinementCount === 0) return
      const refines = refinementCount - 1
      if (refines > 0) {
        const name = "C" + refines
        currentStage = stageDetail[name] || []
      }
      jointUpKeypoints.forEach((item) => {
        if (item.name.includes("R")) up_res.push({ ...item, name: "0" })
        else up_res.push(item)
      })
      jointLowerKeypoints.forEach((item) => {
        if (item.name.includes("R")) low_res.push({ ...item, name: "0" })
        else low_res.push(item)
      })
      if (refines === 0) {
        currentStage = stageDetail?.initial || []
      }
      setupperStage(up_res)
      setlowerStage(low_res)
      // checkStageDifferencesForQuote(up_res, low_res)
      setup_current(Number(up_res[up_res.length - 1]?.name) || 0)
      setdown_current(Number(low_res[low_res.length - 1]?.name) || 0)
      let upper_print = [],
        upper_order = [],
        lower_print = [],
        lower_order = []

      for (let index = 0; index < currentStage.length; index++) {
        const { arch_type, stage, status } = currentStage[index]
        if (arch_type === 0) {
          if (status === "IN_OFFICE") {
            upper_print = [...upper_print, stage]
            if (stage > 500) {
              upper_print.push(500)
            } else if (stage >= 400) {
              upper_print.push(400)
            }
          }
          if (status === "PREVIOUSLY_ORDERED") {
            upper_order = [...upper_order, stage]
            if (stage > 500) {
              upper_order.push(500)
            } else if (stage >= 400) {
              upper_order.push(400)
            }
          }
        } else {
          if (status === "IN_OFFICE") {
            lower_print = [...lower_print, stage]
            if (stage > 500) {
              lower_print.push(500)
            } else if (stage >= 400) {
              lower_print.push(400)
            }
          }
          if (status === "PREVIOUSLY_ORDERED") {
            lower_order = [...lower_order, stage]
            if (stage > 500) {
              lower_order.push(500)
            } else if (stage >= 400) {
              lower_order.push(400)
            }
          }
        }
      }
      setprintedStage({ up: upper_print, low: lower_print })
      setorderStage({ up: upper_order, low: lower_order })
    }, [stageDetail])

    useEffect(() => {
      if (!openReviewPrint) return

      const modulePrintSelection =
        wasmModule.moduleManager.GetModulePrintSelection()
      if (!modulePrintSelection) return

      const upStageCount = stagingManager.stageUpnNumber
      const lowerStageCount = stagingManager.stageLowNumber

      const handleReviewStage = (
        list: number[],
        tempIndex: number,
        stageCount: number,
        isLower: boolean,
      ) => {
        if (list.length === 0) return

        const lastStage = list[list.length - 1]
        const arch = isLower ? 1 : 0

        isLower
          ? setLowerReviewStage(lastStage)
          : setUpperReviewStage(lastStage)

        const isRetainerStage = lastStage === 500

        const finalStage =
          lastStage === 400
            ? Math.max(0, tempIndex - 1)
            : isRetainerStage
            ? stageCount
            : lastStage

        const stageType = lastStage === 400 ? 2 : isRetainerStage ? 1 : 0

        modulePrintSelection.ShowOutputStage(finalStage, stageType, arch)
      }

      if (printedStageInPrint.up.length > 0) {
        handleReviewStage(
          printedStageInPrint.up,
          attachment.up,
          upStageCount,
          false,
        )
      } else if (printedStageInPrint.low.length > 0) {
        handleReviewStage(
          printedStageInPrint.low,
          attachment.low,
          lowerStageCount,
          true,
        )
      }
    }, [
      openReviewPrint,
      printedStageInPrint.up,
      printedStageInPrint.low,
      attachment.up,
      attachment.low,
      stagingManager,
    ])

    /**
     *  .function("IsCuttinglineChanged", &UModulePrintSelection::IsCuttinglineChanged)
        .function("ApplyCuttinglineChanges", &UModulePrintSelection::ApplyCuttinglineChanges)
        .function("SaveOutputFiles", &UModulePrintSelection::SaveOutputFiles)
        提供了三个接口：
        第一个判断cuttingline有无修改，返回bool
        第二个是yes的执行函数
        第三个是保存所有
     */
    const handleCutLineWarningConfirm = () => {
      const modulePrintSelection =
        wasmModule.moduleManager.GetModulePrintSelection()
      if (!modulePrintSelection) return // modulePrintSelection is null when the module is not loaded

      modulePrintSelection.ApplyCuttinglineChanges()

      if (pendingStageAction) {
        const { upperarch, index } = pendingStageAction
        upperarch ? setUpperReviewStage(index) : setLowerReviewStage(index)
      }
    }

    const handleShowOutputStage = (
      reviewStage: number,
      attFirstIndex: number,
      isRetainerStage: boolean,
      stageCount: number,
      arch: 0 | 1, // 0: upper, 1: lower
    ) => {
      const modulePrintSelection =
        wasmModule.moduleManager.GetModulePrintSelection()
      if (!modulePrintSelection || reviewStage < 0) return

      const stageIndex =
        reviewStage === 400
          ? Math.max(0, attFirstIndex - 1)
          : isRetainerStage
          ? stageCount
          : reviewStage

      const stageType = reviewStage === 400 ? 2 : isRetainerStage ? 1 : 0

      modulePrintSelection.ShowOutputStage(stageIndex, stageType, arch)
    }

    const resetCuttingLine = () => {
      console.log("resetCuttingLine")
      const modulePrintSelection =
        wasmModule.moduleManager.GetModulePrintSelection()
      if (!modulePrintSelection) return

      const stage =
        upperReviewStage > lowerReviewStage
          ? upperReviewStage
          : lowerReviewStage
      const upperarch = upperReviewStage > lowerReviewStage ? true : false

      const attFirstIndex = upperarch ? attachment.up : attachment.low
      const isRetainerStage = stage === 500
      const stageCount = upperarch
        ? stagingManager.stageUpnNumber
        : stagingManager.stageLowNumber
      const arch = upperarch ? 0 : 1

      handleShowOutputStage(
        stage,
        attFirstIndex,
        isRetainerStage,
        stageCount,
        arch,
      )
    }

    useEffect(() => {
      if (upperReviewStage < 0) return
      const isUpRetainerStage = upperReviewStage === 500
      handleShowOutputStage(
        upperReviewStage,
        attachment.up,
        isUpRetainerStage,
        stagingManager.stageUpnNumber,
        0,
      )
      setLowerReviewStage(-1)
    }, [upperReviewStage])

    useEffect(() => {
      if (lowerReviewStage < 0) return

      const isLowerRetainerStage = lowerReviewStage === 500
      handleShowOutputStage(
        lowerReviewStage,
        attachment.low,
        isLowerRetainerStage,
        stagingManager.stageLowNumber,
        1,
      )
      setUpperReviewStage(-1)
    }, [lowerReviewStage])

    // stage component
    const stageComponent = (
      upperarch = true,
      upperStage,
      lowerStage,
      retainers,
      selectedStage,
      attachment,
    ) => {
      const stageListComponent = [],
        stageNumber = upperarch ? upperStage.length : lowerStage.length,
        stage = upperarch ? upperStage : lowerStage,
        Tattachment = upperarch ? attachment.up : attachment.low,
        isRetainerArch = upperarch
          ? getArch(caseDetail.udesign_category).UpperType === "R"
          : getArch(caseDetail.udesign_category).LowerType === "R"
      // let Crefinement = ""
      let index = 1
      // attachement是否在0 stage
      if (Tattachment === 0 && stageNumber > 0) {
        stageListComponent.push(
          stageStatusMap({
            stageStatus: getStepStatus(400, upperarch),
            index: 400,
            upperarch,
          }),
        )
      }
      // 非 retainer arch
      if (!isRetainerArch) {
        for (; index < stageNumber; index++) {
          const { name } = stage[index]
          const numericName = Number(name)
          const isLastStage = index === stageNumber - 1
          const isAttachmentMatched =
            Tattachment > 0 && Number(stage[Tattachment]?.name) === numericName

          // 插入T阶段（attachment stage 前加一阶段）
          if (isAttachmentMatched) {
            stageListComponent.push(
              stageStatusMap({
                stageStatus: getStepStatus(400, upperarch),
                index: 400,
                upperarch,
              }),
            )
          }

          // 最后一步特殊处理
          if (isLastStage) {
            if (Tattachment < 0) {
              // 没有 T，最后一步是 R
              stageListComponent.push(
                stageStatusMap({
                  stageStatus: getStepStatus(numericName, upperarch),
                  index: numericName,
                  upperarch,
                  isRetainerStage: true,
                }),
              )
            } else {
              stageListComponent.push(
                stageStatusMap({
                  stageStatus: getStepStatus(numericName, upperarch),
                  index: name,
                  upperarch,
                }),
              )
            }
          } else {
            // 普通步骤
            stageListComponent.push(
              stageStatusMap({
                stageStatus: getStepStatus(numericName, upperarch),
                index: name,
                upperarch,
              }),
            )
          }
        }
      }
      const hasJaw = upperarch
        ? wasmModule.getArchModel(EArchType.UpArch)
        : wasmModule.getArchModel(EArchType.LowArch)
      // +should add  RT or R stage
      const shouldAddRStage =
        stageNumber >= 0 && !(stageNumber > 0 && Tattachment < 0) && hasJaw
      const isRT = Tattachment === 0 && stageNumber === 0
      if (shouldAddRStage) {
        stageListComponent.push(
          stageStatusMap({
            stageStatus: getStepStatus(isRT ? 400 : 500, upperarch),
            index: isRT ? 400 : 500,
            upperarch,
            isRt: isRT,
          }),
        )
      }
      return (
        <Box sx={{ marginBottom: "16px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: 38,
              lineHeight: 38,
              width: "100%",
            }}
          >
            <Box display={"flex"} alignItems={"center"}>
              <UText variant="subtitle2">
                {upperarch ? "Upper arch" : "Lower arch"}
              </UText>
            </Box>
          </Box>
          <Box
            display={"flex"}
            flexWrap={"wrap"}
            sx={{
              marginTop: "16px",
              padding: "0 !important",
              marginBottom: 0,
            }}
          >
            {stageListComponent}
          </Box>
        </Box>
      )
    }
    /**
     * find the component by the stage status
     * @param param0
     * @returns
     */
    const stageStatusMap = ({
      stageStatus,
      index,
      upperarch,
      isRetainerStage = false, //whether the stage is the last one
      isRt = false, // whether the stage is RT
    }) => {
      const getLabel = () => {
        if (isRetainerStage) return index + "/R"
        if (index === 500) return "R"
        if (index === 400) return isRt ? "R" : "T"

        return index
      }

      const commonProps = {
        onClick: () => stageHandle({ index, upperarch }),
        sx: {
          marginRight: 1,
          marginBottom: 1,
          boxShadow: "none",
        },
      }

      const statusMap = {
        ordered: {
          variant: "contained",
          sx: {
            backgroundColor: "#03A9F4",
            borderColor: "rgba(2, 136, 209, 0.50)",
            "&:hover": {
              backgroundColor: "rgba(2, 136, 209, 0.30)",
              borderColor: "#0288D1",
            },
          },
        },
        printed: {
          variant: "contained",
          sx: {
            backgroundColor: "#78909C",
            borderColor: "#546E7A",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.08)",
            },
          },
        },
        "order&print": {
          variant: "contained",
          sx: {
            backgroundImage: `url(${orderandprint})`,
            borderColor: "rgba(66, 165, 245, 1)",
            "&:hover": {},
          },
        },
        selected: {
          variant: "contained",
          sx: {
            borderRadius: "4px",
            border: "3px solid var(--success-dark, #1B5E20)",
            background: "var(--success-light, #4CAF50)",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#4CAF50",
            },
          },
        },
        disable: {
          variant: "outlined",
          disabled: true,
          sx: {
            backgroundColor: "#FFFFFF",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          },
        },
        default: {
          variant: "outlined",
          sx: {
            borderRadius: "4px",
            border:
              "1px solid var(--primary-states-outlinedBorder, rgba(33, 150, 243, 0.50))",
            background: "var(--success-light, #4CAF50)",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#4CAF50",
            },
          },
        },
      }

      const currentStatus = statusMap[stageStatus] || statusMap.default

      return (
        <BaseButton
          key={index}
          {...commonProps}
          {...currentStatus}
          sx={{ ...commonProps.sx, ...currentStatus.sx }}
        >
          {getLabel()}
          {isRt && (
            <Box
              sx={{
                position: "absolute",
                top: -4,
                left: 4,
              }}
            >
              <Typography
                variant="caption"
                fontWeight="bold"
                fontSize={12}
                color="red"
              >
                T
              </Typography>
            </Box>
          )}
        </BaseButton>
      )
    }
    const [pendingStageAction, setPendingStageAction] = useState<{
      upperarch: boolean
      index: number
    } | null>(null)
    /**
     * stage button click
     * @param upperarch: true/false
     * @param index: current selected tooth id
     * @returns
     */
    const stageHandle = ({ upperarch, index: _index }) => {
      const modulePrintSelection =
        wasmModule.moduleManager.GetModulePrintSelection()
      if (!modulePrintSelection) return
      const cuttinglineChanged = modulePrintSelection.IsCuttinglineChanged()
      console.log("cuttinglineChanged:", cuttinglineChanged)
      if (cuttinglineChanged) {
        setPendingStageAction({
          upperarch,
          index: Number(_index),
        })
        setShowCutLineWarning(true)
        return
      }

      upperarch
        ? setUpperReviewStage(Number(_index))
        : setLowerReviewStage(Number(_index))
    }
    /**
     *
     * @param index  number
     * @param upperarch boolean
     * @returns
     */
    const getStepStatus = (index, upperarch) => {
      const reviewStage = upperarch ? upperReviewStage : lowerReviewStage,
        selectedStageInPrint = upperarch
          ? printedStageInPrint.up
          : printedStageInPrint.low

      let stageStatus = "disable"
      if (
        selectedStageInPrint &&
        selectedStageInPrint.indexOf(Number(index)) !== -1
      ) {
        stageStatus = "default"
      }

      if (reviewStage === Number(index)) {
        stageStatus = "selected"
      }

      return stageStatus
    }
    return (
      <>
        <Box id="stageBox" sx={{ flex: 1 }}>
          {/* <Box sx={{ padding: "16px 0", marginTop: "20px" }}>
          <UText variant="h6">Reivew output models</UText>
        </Box> */}
          <Box>
            <Box>
              {stageComponent(
                true,
                upperStage,
                lowerStage,
                retainers,
                selectedStage,
                attachment,
              )}
            </Box>

            <Box sx={{ overflowY: "hidden" }}>
              {stageComponent(
                false,
                upperStage,
                lowerStage,
                retainers,
                selectedStage,
                attachment,
              )}
            </Box>
          </Box>
        </Box>

        <Dialog
          open={showCutlineWarning}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ color: "black" }}
            >
              Do you want to save the change of cutting line?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                color: "black",
                backgroundColor: "rgb(224,224,224)",
              }}
              onClick={() => {
                if (pendingStageAction) {
                  const { upperarch, index } = pendingStageAction

                  if (
                    index === (upperarch ? upperReviewStage : lowerReviewStage)
                  )
                    resetCuttingLine()
                  else
                    upperarch
                      ? setUpperReviewStage(index)
                      : setLowerReviewStage(index)
                }
                setPendingStageAction(null)
                setShowCutLineWarning(false)
              }}
            >
              NO
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleCutLineWarningConfirm()
                setPendingStageAction(null)
                setShowCutLineWarning(false)
              }}
              autoFocus
            >
              YES
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  },
)
export default ReviewPrintStage
